import { render } from "./ReviewsView.vue?vue&type=template&id=7a0045ef&lang=pug"
import script from "./ReviewsView.vue?vue&type=script&lang=js"
export * from "./ReviewsView.vue?vue&type=script&lang=js"

import "./ReviewsView.vue?vue&type=style&index=0&id=7a0045ef&lang=scss&global=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__